<template>
    <div class="information-sharing-list">
        <header class="header">
            <h1 class="title">第三方信息共享清单</h1>
            <p class="subtitle">您授权同意我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
        </header>

        <main class="sdk-list">
            <div v-for="(sdk, index) in sdkList" :key="index" class="sdk-item">
                <div class="sdk-item-header">
                    <h4 class="sdk-name">{{ index + 1 }}. {{ sdk.name }}</h4>
        </div>
                <div class="sdk-item-content">
                    <div class="info-row">
                        <span class="label">第三方公司名称:</span>
                        <span class="value">{{ sdk.company }}</span>
        </div>
                    <div class="info-row">
                        <span class="label">共享类型:</span>
                        <span class="value">{{ sdk.type }}</span>
        </div>
                    <div class="info-row">
                        <span class="label">共享信息:</span>
                        <div class="value" v-html="sdk.sharedInfo"></div>
        </div>
                    <div class="info-row">
                        <span class="label">使用目的:</span>
                        <span class="value">{{ sdk.purpose }}</span>
        </div>
                    <div class="info-row">
                        <span class="label">使用场景:</span>
                        <span class="value">{{ sdk.scenario }}</span>
        </div>
                    <div class="info-row">
                        <span class="label">共享方式:</span>
                        <span class="value">{{ sdk.shareMethod }}</span>
        </div>
                    <div class="info-row">
                        <span class="label">第三方隐私链接:</span>
                        <span class="value"><a :href="sdk.privacyLink" target="_blank" rel="noopener noreferrer">{{sdk.privacyLink}}</a></span>
        </div>
        </div>
        </div>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sdkList: [
                {
                    name: '友盟+移动统计SDK（com.umeng.analytics）',
                    company: '友盟同欣（北京）科技有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '友盟+SDK采集唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID 信息）、位置信息、网络信息、获取应用列表',
                    purpose: '对用户进行唯一标识',
                    scenario: '统计用户新增等数据、剔除作弊设备',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://www.umeng.com/page/policy'
                },
                {
                    name: '日志服务（SLS）SDK',
                    company: '阿里云计算有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '对用户进行唯一标识',
                    scenario: '提供数据管理同步、统计分析的功能服务',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html'
                },
                {
                    name: '优量汇SDK',
                    company: '深圳市腾讯计算机系统有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息；无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址；设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）；设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）；获取运行中进程信息、获取应用安装列表；精确位置信息、粗略位置信息；获取设备硬件序列号、获取Android ID、获取 MAC 地址、设备IP地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983'
                },
                {
                    name: '穿山甲广告 SDK（com.bytedance）',
                    company: '北京巨量引擎网络技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '设备标识符（如IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，IDFV、IDFA、ODID），设备MAC地址，IP地址，精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID、BSSID）），设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、获取设备硬件序列号、获取Android ID',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://www.csjplatform.com/privacy'
                },
                {
                    name: '京准通 SDK',
                    company: '北京京东世纪贸易有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://jzt.jd.com/gw/agreement'
                },
                {
                    name: '蒂烨 SDK',
                    company: '蒂烨大数据科技（广州）有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://bxr.im/activity/html/m20200803Agreements/html/dierdodo_policy.html'
                },
                {
                    name: 'MMA 中国广告监测通用SDK',
                    company: '上海亦拓广告有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://mmachina.cn/sdk-privacy/'
                },
                {
                    name: '创智汇聚 SDK（Sigmob SDK）',
                    company: '北京创智汇聚科技有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://newdocs.toponad.com/docs/1Mn1B7'
                },
                {
                    name: '快手联盟 SDK',
                    company: '北京快手广告有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://u.kuaishou.com/home/detail/1220'
                },
                {
                    name: '小米推送 SDK（ Milink SDK）',
                    company: '北京小米科技有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '实现消息推送服务',
                    scenario: '消息推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://dev.mi.com/distribute/doc/details?pId=1534'
                },
                {
                    name: '魅族推送 SDK',
                    company: '珠海星纪魅族信息技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '实现消息推送服务',
                    scenario: '消息推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://open.flyme.cn/docs?id=202'
                },
                {
                    name: '华为推送 SDK',
                    company: '华为软件技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '实现消息推送服务',
                    scenario: '消息推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177'
                },
                {
                    name: 'OPPO推送 SDK',
                    company: '广东欢太科技有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '实现消息推送服务',
                    scenario: '消息推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://open.oppomobile.com/new/developmentDoc/info?id=10288'
                },
                {
                    name: 'vivo推送 SDK',
                    company: '维沃移动通信有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '实现消息推送服务',
                    scenario: '消息推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://dev.vivo.com.cn/documentCenter/doc/652'
                },
                {
                    name: '创蓝闪验 SDK（chuanglan-sms-operator）',
                    company: '上海璟梦信息科技有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '用于帮助实现用户一键登录行为；提供反欺诈等功能',
                    scenario: '本机号码一键登录',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://sdk.253.com/commit-detail/rcc5zd/fd21s8'
                },
                {
                    name: '腾讯Bugly SDK（com.tencent.bugly）',
                    company: '深圳市腾讯计算机系统有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志；获取设备硬件序列号、获取Android ID。',
                    purpose: '用于提供崩溃日志上报、热修复、版本更新推送的服务。',
                    scenario: '崩溃日志上报、热修复、版本更新推送',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56'
                },
                {
                    name: '华为联运应用 SDK（Android版）',
                    company: '华为软件技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '提供用户华为帐号登录功能与联运支付功能',
                    scenario: '华为帐号登录、联运支付',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-app-sdk-security-0000001714810945'
                },
                {
                    name: '支付宝客户端 SDK',
                    company: '支付宝（中国）网络技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: 'Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。',
                    purpose: '保障用户账户和资金安全以及支付服务的安全稳定运行。履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。实现网络链路的选择和优化，以提升用户体验。',
                    scenario: '用户使用支付宝账号支付',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://opendocs.alipay.com/common/02kiq3'
                },
                {
                    name: '微信支付 SDK',
                    company: '深圳市腾讯计算机系统有限公司',
                    type: '内嵌SDK',
                    sharedInfo: 'Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备硬件序列号。',
                    purpose: '保障用户账户和资金安全以及支付服务的安全稳定运行。履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。实现网络链路的选择和优化，以提升用户体验。',
                    scenario: '用户使用微信账号支付',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8'
                },
                {
                    name: '华为应用内支付SDK',
                    company: '华为软件技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。设备信息（设备标识符）、帐号信息（华为帐号ID）、商业公开发布的内容（应用基本信息）、设备信息（国家码、操作系统、产品品牌）、应用信息（内容下载渠道、应用功能设置、应用使用记录）、设备硬件信息（设备类型）；获取设备硬件序列号、获取Android ID、获取 MAC 地址。',
                    purpose: '提供用户华为联运支付功能。',
                    scenario: '用户使用华为联运支付',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906'
                },
                {
                    name: '新浪微博开放平台 SDK',
                    company: '北京微梦创科网络技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '设备基础信息：唯一设备识别码 IMEI、IMSI 信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本、设备IP、获取设备硬件序列号、获取Android ID、获取 MAC 地址',
                    purpose: '提供微博分享功能',
                    scenario: '用户分享内容',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE#.E9.9A.90.E7.A7.81.E7.9B.B8.E5.85.B3.E6.9D.A1.E6.AC.BE'
                },
                {
                    name: '倍孜SDK',
                    company: '上海倍孜网络技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: "【Android+iOS+HarmonyOS】设备品牌、设备型号、设备时区、设备语言、系统版本、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、磁盘空间、物理内存、网络类型、运营商、开发者应用名、应用版本号、应用包名、产品交互数据、广告数据(展示、点击、转化)、崩溃数据、性能数据、粗略位置信息、加速度传感器、陀螺仪<br/>【Android+iOS】系统更新时间、精确位置信息、重力传感器、方向传感器、压力传感器、线性加速度传感器<br/>【Android+HarmonyOS】OAID<br/>【iOS+HarmonyOS】设备名称<br/>【仅Android】cpu、sim卡状态、运行状态<br/>【仅iOS】开机时间、IDFA、IDFV、磁力传感器",
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '广告投放',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://sdk-doc.adn-plus.com.cn/docs/Privacy_Protection'
                },
                {
                    name: '七牛 SDK',
                    company: '上海七牛信息技术有限公司',
                    type: '内嵌SDK',
                    sharedInfo: '设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址',
                    purpose: '广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务',
                    scenario: '提供音频文件下载完整性校验、以及用户帐号头像上传的服务',
                    shareMethod: '（外部）接口共享',
                    privacyLink: 'https://developer.qiniu.com/pili/8027/sdk-privacy-policy'
                }
            ]
        }
    },
}
</script>

<style lang='scss' scoped>
// 假设 px2html 是一个存在的 scss 函数, 如果不是, 可以替换为 rem 或 px
@function px2html($px) {
  @return $px * 1; // 这是一个简单的替代实现
}

.information-sharing-list {
    padding: px2html(15px);
    background-color: #f7f8fa;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    color: #333;
}

.header {
    text-align: left;
    margin-bottom: px2html(25px);

    .title {
        font-size: px2html(22px);
        font-weight: 600;
        margin-bottom: px2html(10px);
    }

    .subtitle {
        font-size: px2html(14px);
        color: #666;
        line-height: 1.6;
        text-align: left;
    }
}

.sdk-list {
    display: flex;
    flex-direction: column;
    gap: px2html(15px);
}

.sdk-item {
    background-color: #fff;
    border-radius: px2html(8px);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
}

.sdk-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2html(15px) px2html(20px);
    transition: background-color 0.2s ease;

    .sdk-name {
            font-size: px2html(16px);
        font-weight: 500;
        color: #2c3e50;
    }
}

.sdk-item-content {
    padding: px2html(5px) px2html(20px) px2html(20px);
    border-top: 1px solid #ebedf0;

    .value {
        color: #666;
        line-height: 1.5;
        word-break: break-all;

        a {
            color: #007bff;
            text-decoration: none;
            &:hover {
            text-decoration: underline;
            }
        }
    }
}

.info-row {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: px2html(12px);
    font-size: px2html(14px);

    .label {
        font-weight: 600;
        color: #555;
        margin-bottom: px2html(5px);
    }
}
</style>